import { render } from "./MobileAccountBill.vue?vue&type=template&id=2c22150e&scoped=true"
import script from "./MobileAccountBill.vue?vue&type=script&lang=js"
export * from "./MobileAccountBill.vue?vue&type=script&lang=js"

import "./MobileAccountBill.vue?vue&type=style&index=0&id=2c22150e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c22150e"],['__file',"src/views/mobile/account_center/components/MobileAccountBill.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c22150e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c22150e', __exports__)) {
    api.reload('2c22150e', __exports__)
  }
  
  module.hot.accept("./MobileAccountBill.vue?vue&type=template&id=2c22150e&scoped=true", () => {
    api.rerender('2c22150e', render)
  })

}


export default __exports__